

<template>

  <div>
    <transition name="plus-icon2">
        <div v-if="codeOpen" class="member-box-popup pa"></div>
    </transition>
    <transition name="plus-icon">

      <!-- 说明信息弹窗 -->
      <div class="popCuponBox popBox" v-if="codeOpen">
        <div class="mask" @click="codeOpen=false"></div>
        <div class="popCupon bg-000 popCont">                              
          <div class="member-box-w pad-20">
            <div class="center mag-t-20">
              <img class="member-box-code" src="/static/member_03.jpg" />
            </div>
            <div class="mag-t-35 f-30 cff5 center">8797 4669 9830 221</div>
            <div
              class="l-height-1-5 mag-t-20 c9b f-16 center member-box-tip"
            >When using it, please show the QR code or barcodeto the studio staff</div>
            <div class="center mag-t-30">
              <img class="member-box-code2" src="/static/member_07.jpg" />
            </div>
          </div>

            <div class="close pa" @click="codeOpen=false"><img src="../../../assets/images/tipIcon3.png" /></div>
        </div>    
    </div>

   
    </transition>
  </div>
 
</template>
<style  scoped="scoped">
  .popCuponBox .popCupon{ width: 450px;}
</style>

<script>
import bus from '@/utils/bus'
export default {
  name: "codes",
  data() {
    return {
      codeOpen:false
    };
  },
  created() {},
  mounted(){
    bus.$on('codeMessage', (e) => {
        this.codeOpen = true;
        console.log(e)
    })
  },
  methods: {
   
  },
  computed: {
    sum: function () {
      console.log(this.fileList_s);
      return this.fileList_s;
    },
  },
  watch: {
    fileList_s: function (val) {
      console.log(val);

      if (0) {
        //添加默认
        if (val instanceof Array) {
          var a = [];
          $.each(val, function (i, v) {
            a.push({ url: v });
          });
          console.log(a);
          this.fileList = a;
        } else {
          this.fileList = [{ url: val }];
        }
      }
    },
  },
};
</script>





// WEBPACK FOOTER //
// src/components/global/codes/index.vue